import Card from "@material-ui/core/Card";
import { AnnouncementList_announcements_edges_node } from "@saleor/announcements/types/AnnouncementList";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { FilterPageProps, PageListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import AnnouncementThumbmailList from "../AnnouncementThumbmailList";
import {
  AnnouncementFilterKeys,
  AnnouncementListUrlFiltersOpts,
  createFilterStructure
} from "./filters";

export interface AnnouncementTableProps
  extends PageListProps,
    TabPageProps,
    FilterPageProps<AnnouncementFilterKeys, AnnouncementListUrlFiltersOpts> {
  announcements: AnnouncementList_announcements_edges_node[];
}

export const AnnouncementListPage: React.FC<AnnouncementTableProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  currencySymbol,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <PageHeader
        title={intl.formatMessage(sectionNames.announcements)}
      ></PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          tabs={tabs}
          filterStructure={structure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Announcements"
          })}
          initialSearch={initialSearch}
          onSearchChange={onSearchChange}
          onFilterChange={onFilterChange}
          onAll={onAll}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <AnnouncementThumbmailList
          toolbar={null}
          toggle={null}
          toggleAll={null}
          isChecked={null}
          selected={null}
          {...listProps}
        />
      </Card>
    </Container>
  );
};
AnnouncementListPage.displayName = "AnnouncementListPage";
export default AnnouncementListPage;
